import { post } from "../../api/HttpClient.js";
import { BASE_URL, HomeScreenBookings_url, InvitationGuestBookings_url, CheckInForGuestUser_url,
     ReportParkingViolationForGuest_url, GetAlternateParkingSpotForGuest_url
 } from "../../config/ApiConfig.js";
import { AppConstant } from "../../config/AppConstants.js";

export const HomeScreenBookings_api = (requestParams) => {
    requestParams.AppVersion = AppConstant.AppVersion;
    requestParams.Language = AppConstant.Language;
    requestParams.DeviceID = AppConstant.DeviceID;
    requestParams.OsVersion = AppConstant.OsVersion;
    requestParams.ManufactureModel = AppConstant.ManufactureModel;
    return post({
        url: `${BASE_URL}${HomeScreenBookings_url}`,
        params: requestParams,
    });
};

export const InvitationGuestBookings_api = (requestParams) => {
    requestParams.AppVersion = AppConstant.AppVersion;
    requestParams.Language = AppConstant.Language;
    requestParams.DeviceID = AppConstant.DeviceID;
    requestParams.OsVersion = AppConstant.OsVersion;
    requestParams.ManufactureModel = AppConstant.ManufactureModel;
    return post({
        url: `${BASE_URL}${InvitationGuestBookings_url}`,
        params: requestParams,
    });
};

export const CheckInForGuestUser_api = (requestParams) => {
    requestParams.AppVersion = AppConstant.AppVersion;
    requestParams.Language = AppConstant.Language;
    requestParams.ManufactureModel = AppConstant.ManufactureModel;
    requestParams.DeviceId = AppConstant.DeviceID;
    requestParams.OsVersion = AppConstant.OsVersion;
    requestParams.App = AppConstant.App;
    requestParams.ClaimFromFlag = AppConstant.ClaimFromFlag;
    requestParams.Longitude = AppConstant.Longitude;
    requestParams.Latitude = AppConstant.Latitude;
    requestParams.CheckInType = 2;
    requestParams.ScanTime = 0; // if QR code then checkInLevelType === 4 ? 1 : 0, for future to use
    
    return post({
        url: `${BASE_URL}${CheckInForGuestUser_url}`,
        params: requestParams,
    });
};

export const ReportParkingViolationForGuest_api = (requestParams) => {
    requestParams.AppVersion = AppConstant.AppVersion;
    requestParams.Language = AppConstant.Language;
    requestParams.ManufactureModel = AppConstant.ManufactureModel;
    requestParams.DeviceId = AppConstant.DeviceID;
    requestParams.OsVersion = AppConstant.OsVersion;
    return post({
        url: `${BASE_URL}${ReportParkingViolationForGuest_url}`,
        params: requestParams,
    });
};
export const GetAlternateParkingSpotForGuest_api = (requestParams) => {
    requestParams.AppVersion = AppConstant.AppVersion;
    requestParams.Language = AppConstant.Language;
    requestParams.ManufactureModel = AppConstant.ManufactureModel;
    requestParams.DeviceId = AppConstant.DeviceID;
    requestParams.OsVersion = AppConstant.OsVersion;
    return post({
        url: `${BASE_URL}${GetAlternateParkingSpotForGuest_url}`,
        params: requestParams,
    });
};
